/* Varsity Jacket Club — cart quantity lock.
   Custom-built jackets and their matching "Personalization & Add-ons" fee line
   must keep the same quantity, or the add-on total would desync. This locks the
   quantity controls on any cart line the builder created (identified by the
   hidden "_locked" line-item property). Loads site-wide; does nothing unless a
   locked line is present. Tuned for the Ella theme (data-line keyed inputs). */
(function () {
  "use strict";
  var TAG = "_locked";

  function injectStyle() {
    if (document.getElementById("vjc-lock-style")) return;
    var s = document.createElement("style");
    s.id = "vjc-lock-style";
    s.textContent =
      ".vjc-locked-qty{pointer-events:none!important;background:transparent!important;border-color:transparent!important;-moz-appearance:textfield;text-align:center}" +
      ".vjc-locked-qty::-webkit-inner-spin-button,.vjc-locked-qty::-webkit-outer-spin-button{-webkit-appearance:none;display:none}" +
      ".vjc-lock-note{display:block;font-size:11px;color:#857f72;margin-top:4px;letter-spacing:.02em}";
    document.head.appendChild(s);
  }

  function lockKey(key) {
    var vid = key.split(":")[0];
    var inputs = document.querySelectorAll(
      'input[data-line="' + key + '"], input[data-cart-quantity-id="' + vid + '"], input[data-key="' + key + '"], input[name="updates[]"][data-key="' + key + '"]'
    );
    inputs.forEach(function (inp) {
      if (inp.__vjcLocked) return;
      inp.setAttribute("readonly", "readonly");
      inp.setAttribute("aria-readonly", "true");
      inp.classList.add("vjc-locked-qty");
      inp.tabIndex = -1;
      var host = inp.closest('cart-update-quantity, .cart-item-quantity, [class*="quantity"]') || inp.parentElement;
      if (host) {
        host.querySelectorAll('button, a[href*="quantity"], [data-action], [class*="minus"], [class*="plus"]').forEach(function (b) {
          b.style.display = "none";
        });
        if (!host.querySelector(".vjc-lock-note")) {
          var n = document.createElement("span");
          n.className = "vjc-lock-note";
          n.textContent = "Qty set in builder";
          host.appendChild(n);
        }
      }
      inp.__vjcLocked = true;
    });
  }

  var running = false;
  function apply() {
    if (running) return;
    running = true;
    fetch("/cart.js", { headers: { Accept: "application/json" }, credentials: "same-origin" })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        running = false;
        if (!cart || !cart.items) return;
        var keys = cart.items
          .filter(function (it) { return it.properties && (it.properties[TAG] === "1" || it.properties[TAG] === 1); })
          .map(function (it) { return it.key; });
        if (!keys.length) return;
        injectStyle();
        keys.forEach(lockKey);
      })
      .catch(function () { running = false; });
  }

  function boot() {
    apply();
    var t;
    var mo = new MutationObserver(function () { clearTimeout(t); t = setTimeout(apply, 350); });
    mo.observe(document.body, { childList: true, subtree: true });
    document.addEventListener("click", function () { setTimeout(apply, 600); }, true);
  }

  if (document.readyState !== "loading") boot();
  else document.addEventListener("DOMContentLoaded", boot);
})();
